import styled, { css } from 'styled-components';
import { Title } from '../Style';
export const SubTitle = styled.p.withConfig({
  displayName: "Style__SubTitle",
  componentId: "sc-1v13oae-0"
})(["margin-bottom:6px;font-size:", "px;line-height:1.29;"], ({
  theme: {
    fontSize
  }
}) => fontSize.default);
export const DetailsRouteColumn = styled.div.withConfig({
  displayName: "Style__DetailsRouteColumn",
  componentId: "sc-1v13oae-1"
})(["flex-basis:50%;margin:0 30px;"]);
export const DetailsRoute = styled.div.withConfig({
  displayName: "Style__DetailsRoute",
  componentId: "sc-1v13oae-2"
})(["display:flex;margin:0 -30px;"]);
export const DetailsRouteInfo = styled.div.withConfig({
  displayName: "Style__DetailsRouteInfo",
  componentId: "sc-1v13oae-3"
})(["margin-bottom:24px;font-size:", "px;p{margin-bottom:8px;line-height:1.29;}.bold{font-weight:500;}", ""], ({
  theme: {
    fontSize
  }
}) => fontSize.default, ({
  isMobile = false
}) => isMobile && css(["padding:20px 16px;margin-bottom:0;"]));
export const DetailsCriticalInfoWrapper = styled.div.withConfig({
  displayName: "Style__DetailsCriticalInfoWrapper",
  componentId: "sc-1v13oae-4"
})(["display:block;min-height:auto;margin-top:32px;"]);
export const DetailsCriticalInfo = styled.div.withConfig({
  displayName: "Style__DetailsCriticalInfo",
  componentId: "sc-1v13oae-5"
})(["display:flex;align-items:center;padding:15px;border:solid 1px ", ";border-radius:6px;"], ({
  theme: {
    color
  }
}) => color.orange);
export const DetailsCriticalInfoIcon = styled.div.withConfig({
  displayName: "Style__DetailsCriticalInfoIcon",
  componentId: "sc-1v13oae-6"
})(["align-self:start;margin-right:15px;font-size:120%;color:", ";"], ({
  theme: {
    color
  }
}) => color.orange);
export const DetailsCriticalInfoText = styled.div.withConfig({
  displayName: "Style__DetailsCriticalInfoText",
  componentId: "sc-1v13oae-7"
})(["font-size:", "px;"], ({
  theme: {
    fontSize
  }
}) => fontSize.default);
export const DetailsTimeInRoad = styled.div.withConfig({
  displayName: "Style__DetailsTimeInRoad",
  componentId: "sc-1v13oae-8"
})(["margin-bottom:5px;font-size:", "px;line-height:18px;color:#909090;"], ({
  theme: {
    fontSize
  }
}) => fontSize.sm);
export const LocalTimeInfo = styled.p.withConfig({
  displayName: "Style__LocalTimeInfo",
  componentId: "sc-1v13oae-9"
})(["margin-bottom:10px;font-size:", "px;"], ({
  theme: {
    fontSize
  }
}) => fontSize.sm);
export { Title };